var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"transparent",attrs:{"flat":"","width":"40"}},[_c('v-img',{attrs:{"src":require("@/assets/images/partners-colored.png"),"height":"48","contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }